import isNil from 'ramda/src/isNil';
import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { AnyTask } from '~common/helper/mobx-tasks';
import { Color } from '~common/model/basics';
import { Dialog, DialogProps } from '~web/view/components/layout/dialog.component';
import { Button } from '~common/components/button/button.component';
import { StateButton } from '~common/components/button/state-button.component';
import { Span } from '~common/components/span.component';

interface Props extends Omit<DialogProps, 'disableBackdropClick' | 'onCancel'> {
  title: string;
  renderBody?: () => ReactNode;
  onYes?: () => void;
  yesLabel?: string;
  yesTask?: AnyTask;
  onNo?: () => void;
  noLabel?: string;
}

export const YesNoDialog: React.FunctionComponent<Props> = ({
  title,
  renderBody,
  onYes,
  yesLabel,
  yesTask,
  onNo,
  noLabel,
  ...rest
}) => {
  const { t } = useTranslation();

  return (
    <Dialog disableBackdropClick {...rest}>
      <Title>{title}</Title>
      {!isNil(renderBody) && <Body>{renderBody()}</Body>}
      {!isNil(onYes) && (
        <YesButton onClick={onYes} task={yesTask}>
          {yesLabel ? yesLabel : t('button.dialog.yes')}
        </YesButton>
      )}
      {!isNil(onNo) && (
        <NoButton onClick={onNo} single={!onYes} color={Color.Gray}>
          {noLabel ? noLabel : t('button.dialog.no')}
        </NoButton>
      )}
    </Dialog>
  );
};

const Title = styled(Span)`
  font-weight: bold;
  line-height: 32px;
  font-size: 26px;
  color: ${(props): string => props.theme.colors.white};
  text-align: center;
  margin-bottom: 15px;
  white-space: pre-wrap;
  max-width: 100%;
`;

const Body = styled(Span)`
  font-weight: 500;
  line-height: 24px;
  font-size: 15px;
  letter-spacing: 0.3px;
  text-align: center;
  color: ${(props): string => props.theme.colors.white};
  margin-top: 15px;
`;

const YesButton = styled(StateButton)`
  && {
    width: 100%;
    margin-top: 30px;
  }
`;

const NoButton = styled(({ single, ...rest }) => <Button {...rest} />)`
  && {
    width: 100%;
    margin-top: ${(props): string => (props.single ? '30px' : '20px')};
    background: ${(props): string => props.theme.colors.withAlpha(props.theme.colors.white)(0.12)};
  }
`;



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/web/src/js/view/components/layout/yes-no-dialog.component.tsx